import { ActionButtonVariants } from 'components/action-button';

export default {
  buttonVariant: ActionButtonVariants.PRIMARY,
  hasStartIcon: true,
  showNumItems: true,
  isSquare: true
};
